module.exports = __webpack_public_path__ + "assets/img/tu.f15a9236.jpg";